/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A10Inputs */

const et_faq_a10 = /** @type {(inputs: Faq_A10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ScalingWebsil on 3-kuuline esmane koostööperiood, sest SEO, lokaalne nähtavus ja konversiooni optimeerimine vajavad tulemuste loomiseks aega. Pärast esimest perioodi on koostöö igakuiselt tühistatav. Meie eesmärk on olla partner, mitte pantvangilepinguga teenusepakkuja. Kui töö ei loo nähtavust, päringuid ega ärilist väärtust, peab kliendil olema võimalus koostöö lõpetada. Seetõttu keskendume mõõdetavatele tulemustele, mitte lihtsalt tegevuste nimekirjale.`)
};

const en_faq_a10 = /** @type {(inputs: Faq_A10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ScalingWebs has an initial 3-month collaboration period because SEO, local visibility, and conversion optimization need time to produce results. After that first period, the service is cancellable monthly. Our goal is to be a partner, not a provider with a hostage-style contract. If the work doesn't create visibility, inquiries, or business value, the client must be able to end the collaboration. That's why we focus on measurable outcomes, not just a list of activities.`)
};

/**
* | output |
* | --- |
* | "ScalingWebs has an initial 3-month collaboration period because SEO, local visibility, and conversion optimization need time to produce results. After that f..." |
*
* @param {Faq_A10Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a10 = /** @type {((inputs?: Faq_A10Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A10Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a10(inputs)
	return en_faq_a10(inputs)
});